import React, { Component } from "react";
import ReactMapGL, { Marker, NavigationControl } from "react-map-gl";
import { Icon } from "@material-ui/core/index";
import { prm } from "../../../mocks";

const pin = require("../../../assets/Pin.svg");

class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewport: {
        width: "100%",
        height: "100vh",
        latitude: 40.877,
        longitude: 14.282828,
        zoom: 16
      }
    };
  }

  render() {
    const { onPinClick, onMapClick } = this.props;

    return (
      <div style={styles.container}>
        <ReactMapGL
          {...this.state.viewport}
          //mapStyle={this.state.mapStyle}
          onViewportChange={viewport => this.setState({ viewport })}
          mapboxApiAccessToken={
            "pk.eyJ1IjoiYWxlcGRiIiwiYSI6ImNrM2c5bTQ3djBjOXozanBnNjZ6cjhna2kifQ.2l-nlwA6zjUFsqP-PNEuUw"
          }
          onClick={() => onMapClick()}
        >
          <div
            style={{ position: "absolute", top: "30%", right: 20, zIndex: 1 }}
          >
            <NavigationControl showZoom showCompass={false} />
          </div>
          {prm.map(item => (
            <Marker longitude={item.lng} latitude={item.lat}>
              <Icon onClick={() => onPinClick(item)}>
                <img
                  className={styles.imageIcon}
                  src={pin}
                  alt={"Passenger Pin"}
                />
              </Icon>
              {/*<Room color={"secondary"} fontSize="large"/>*/}
            </Marker>
          ))}
        </ReactMapGL>
      </div>
    );
  }
}

const styles = {
  container: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: -1
  },
  imageIcon: {
    height: "100%"
  }
};

export default MapView;
